import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { MoonLoader } from 'react-spinners';


export default function People() {
    const [people, setPeople] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);
   
   
    function nextPage(){
        if(pageNumber != 501){
            let x = pageNumber + 1;
            setPageNumber(x)
        }
        else{
            let x = pageNumber;
        }
   }
   function pervPage(){
    if(pageNumber != 1){
        let x = pageNumber - 1;
        setPageNumber(x)
       
    }
    else{
        let x = pageNumber;
    }
     
   }


    async function getPeople() {
        let { data } = await axios.get(`https://api.themoviedb.org/3/person/popular?api_key=0ada3fcaa2e394ff1ad6ed7e6c5db6c5&language=en-US&page=${pageNumber}`);
        setPeople(data.results);

    }
    
    useEffect(() => {
        getPeople()
        
    }, [pageNumber])
    
    

    return <>
        {people ? <div className="container">
            <h1>Popular People</h1>
            <div className="row">
                {people.map((person, idx) => 
                    <div key={idx} className="col-md-3 ">
                        {person.profile_path != null ?
                            <div className='imghov'>
                                <Link to={`/peopledetails/${person.id}`}><img className='w-100 rounded-top ' src={"https://image.tmdb.org/t/p/w500/" + person.profile_path} alt="famous" /></Link>
                                <div className='text-center text-black bg-white rounded-bottom'>
                                    <h5 className='fw-bolder p-3'>{person.name}</h5>
                                </div>
                            </div> :
                            <div className='imghov'>
                                <img className='w-100 bg-white rounded-top' src="/people/Default-welcomer.png" alt="photoless" />
                                <div className='text-center text-black bg-white rounded-bottom'>
                                    <h5 className='fw-bolder p-3'>{person.name}</h5>
                                </div>
                            </div>}
                    </div>
                )}
            </div>
        </div> : <div className='vh-100 d-flex justify-content-center align-items-center'>
    <MoonLoader color="white"/>
    </div>}
        <div className='my-3 text-center'>
            <h4><span><button onClick={pervPage} className='btn btn-outline-light rounded-5 border-0' ><i className="fa-solid fa-angles-left"></i></button></span> {pageNumber} <span><button onClick={nextPage} className='btn btn-outline-light rounded-5 border-0'><i className="fa-solid fa-angles-right"></i></button></span></h4>
        </div>




    </>
}
